var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 39,
    viewBox: "0 0 22 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "#4E26A3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.5C5 9.5 6.2 5.5 11 5.5",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 37C9 38.1046 9.89543 39 11 39C12.1046 39 13 38.1046 13 37L9 37ZM9 24L9 37L13 37L13 24L9 24Z",
    fill: "#4E26A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPMapMarker);
export default __webpack_public_path__ + "static/media/p_map_marker.667f5e300b4124c59f09f3f249777e3d.svg";
export { ForwardRef as ReactComponent };